export const MESSAGING_FEATURE_FLAG = 'rollout.clients.pov_messaging';
export const COMMAND_CENTER_FEATURE_FLAG = 'command_center';

export const PAGE_SIZE = 25;
export const MAX_SELECTED_CONVERSATIONS = 200;

// Icon names come from the shared frontage icomoon set (same icons the legacy inbox uses)
export const FOLDERS = [
  { name: 'inbox', routeName: 'inbox', icon: 'icon-Inbox_POV' },
  { name: 'attention', routeName: 'attention', icon: 'icon-x16-alert' },
  { name: 'follow_up', routeName: 'follow_up', icon: 'icon-Followup-16' },
  { name: 'sent', routeName: 'sent', icon: 'icon-Sent_16' },
  { name: 'archived', routeName: 'archive', icon: 'icon-totalusage-s' },
  { name: 'trash', routeName: 'trash', icon: 'icon-16trash' },
];

export const SOURCES_FOLDER_PREFIX = 'sources_';

// Folder-dependent visible bulk actions (parity with legacy inbox-layout.js.coffee folder_actions)
export const FOLDER_ACTIONS = {
  inbox: ['delete', 'send_lead', 'follow_up'],
  sent: ['follow_up'],
  attention: ['delete', 'send_lead', 'follow_up'],
  follow_up: ['delete', 'send_lead', 'cancel_follow_up'],
  archived: ['move_to_inbox', 'delete', 'send_lead', 'follow_up'],
  trash: ['move_to_inbox', 'send_lead'],
  sources: ['delete', 'send_lead', 'assign', 'follow_up'],
};

// Per-message-type row icons — parity with the legacy conversation-row.js.coffee
// `iconName` switch, which keys off last_message.message_of (the :api values).
// IMPORTANT: these must be REAL glyph names in the POV icon font. The previous
// values (icon-Appointments / icon-Invoices / icon-Documents / icon-Events /
// icon-Payments) do not exist in the font, so those rows rendered blank — hence
// appointments/invoices/etc. showed no icon. Real names verified from live POV
// usage (icon-Calendar_POV, icon-Payments_POV, icon-Documents_POV, icon-Mail,
// icon-Star, icon-Phone1). Types the legacy switch does not map (estimate,
// payment_status, appointment_series, waitlist, …) are intentionally omitted so
// they show no icon in both inboxes.
export const MESSAGE_TYPE_ICONS = {
  appointment: 'icon-Calendar_POV',
  // legacy message_of for events is event_attendance / event_series_attendance (not "event")
  event_attendance: 'icon-Calendar_POV',
  event_series_attendance: 'icon-Calendar_POV',
  invoice: 'icon-Payments_POV',
  payment: 'icon-Payments_POV',
  document: 'icon-Documents_POV',
  message: 'icon-Mail',
  // legacy groups message + announcement onto the same envelope glyph
  announcement: 'icon-Mail',
  review: 'icon-Star',
  call: 'icon-Phone1',
};

export const FORBIDDEN_PERMANENT_DELETE_COUNTRIES = ['France'];

// "New" header menu — fired through the existing quick-action bridge
// (setForceModalMode + fire-quick-action postMessage; Angular opens the dialog in modal mode).
// Names match app/assets/frontage/app/utils/quick-actions-service.js.coffee handlers.
export const NEW_ACTIONS = [
  { name: 'message', labelKey: 'messaging.new_menu.message' },
  { name: 'appointment', labelKey: 'messaging.new_menu.appointment' },
  { name: 'client', labelKey: 'messaging.new_menu.client' },
  { name: 'invoice', labelKey: 'messaging.new_menu.invoice', feature: 'payments_module' },
  { name: 'estimate', labelKey: 'messaging.new_menu.estimate', feature: 'payments_module' },
  { name: 'record_payment', labelKey: 'messaging.new_menu.record_payment', feature: 'payments_module' },
  { name: 'document', labelKey: 'messaging.new_menu.document' },
  { name: 'announcement', labelKey: 'messaging.new_menu.announcement' },
];

export const PANE_IFRAME_ID = 'vue_pane_iframe';
